"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconRefresh = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgWrapper = require("../Icon/SvgWrapper");
const IconRefresh = props => /*#__PURE__*/_react.default.createElement(_SvgWrapper.SvgWrapper, props, /*#__PURE__*/_react.default.createElement("g", {
  clipPath: "url(#mo6e0cl00a)"
}, /*#__PURE__*/_react.default.createElement("path", {
  d: "M13.338.226a1.25 1.25 0 1 0-1.433 2.048l2.264 1.585H12.07C6.51 3.86 2 8.368 2 13.93 2 19.492 6.509 24 12.07 24c5.562 0 10.071-4.509 10.071-10.07a1.25 1.25 0 0 0-2.5 0 7.57 7.57 0 1 1-7.57-7.57h2.098l-2.264 1.584a1.25 1.25 0 0 0 1.434 2.048l4.867-3.407a1.801 1.801 0 0 0 0-2.952L13.34.226z"
})), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
  id: "mo6e0cl00a"
}, /*#__PURE__*/_react.default.createElement("path", {
  d: "M0 0h24v24H0z"
}))));
exports.IconRefresh = IconRefresh;
//# sourceMappingURL=IconRefresh.js.map